import { render, staticRenderFns } from "./MarginSpan.vue?vue&type=template&id=6a1ab082&"
import script from "./MarginSpan.vue?vue&type=script&lang=js&"
export * from "./MarginSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports